  <!-- 应付核销总表 -->
  <template>
  <div>
    <!-- 按钮列表 -->
    <butotn-plug :btndata="BTN_CONFIG" @btnEvent="callBack" @clearBtns="clearBtns" @moreParam="moreParam" @queryBtn_ok="queryBtn_ok" @moreHandle="topCommandBtns" ref="btnList" />
    <!-- 查询列表 -->
    <input-plug ref="queryForm" :form-config="baseConfig" :form-data="queryData" :More="isHaseMore" @changeCallback="rowCallback">
      <template slot="time1">
        <multitime :timeType="timeType" :timeTypes="timeTypes" :startTime="startTime_a" :endTime="endTime_a" @timestatus="timestatus" @queryBtn_ok="queryBtn_time" />
      </template>
    </input-plug>
    <!-- 表格 -->
    <table-plug :tableConfig="tableConfig" :defaulthead="myTableHeard" ref="mytable" :totals="totalArr" @selectChange="handleSelectionChange" @jumpPage="goYdDetails" />
    <!-- 分页 -->
    <paging ref="pags" :pageNum="pageStart" :total="pageCount" :size="pageTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" />
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    />
    <!-- 整单核销 -->
    <my-dialog :diaWidth="diaWidth" :dialogTitle="dialogTitle(1)" :isShowDialog="isShowDialog_1" @handleCloseDia="handleCloseDia(1)" @diaCancelBtn="diaCancelBtn(1)" @diaConfirmBtn="diaConfirmBtn(1)">
      <dia-form :diaFormConfig="diaFormConfig" :baseModel="baseModel" ref="diaform" :rules="formRules_1" :Reset="isShowDialog_1">
        <template slot="phone">
          <uploadimgs @input="changeFileList" :fileNameLists="fileNameLists" :limit="6" />
        </template>
      </dia-form>
    </my-dialog>
    <!-- 部分核销 -->
    <my-dialog :diaWidth="diaWidth" :dialogTitle="dialogTitle(2)" :isShowDialog="isShowDialog_2" @handleCloseDia="handleCloseDia(2)" @diaCancelBtn="diaCancelBtn(2)" @diaConfirmBtn="diaConfirmBtn(2)">
      <dia-form :diaFormConfig="diaFormConfig_2" :baseModel="baseModel_2" ref="diaform_2" :rules="formRules_2" :Reset="isShowDialog_2">
        <template slot="phone">
          <uploadimgs @input="changeFileList_2" :fileNameLists="fileNameLists_2" :limit="6" />
        </template>
      </dia-form>
    </my-dialog>
    <!-- 核销记录 -->
    <my-dialog
      :diaWidth="diaWidth"
      :double="false"
      :dialogTitle="dialogTitle(3)"
      :isShowDialog="isShowDialog_3"
      @handleCloseDia="handleCloseDia(3)"
      @diaCancelBtn="diaCancelBtn(3)"
      @diaConfirmBtn="diaConfirmBtn(3)"
    >
      <record-table :tableConfig="writeoffTable" :tableHeads="W_tableHeads" @selectChange="w_selectChange" @rowCallback="w_rowMethods" />
      <el-dialog title="核销图片" append-to-body :visible.sync="dialogVisible">
        <el-image v-for="(item, index) in srcList" :key="index" style="width: 100px; height: 100px" :src="item" :preview-src-list="srcList" />
      </el-dialog>
    </my-dialog>
    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
      <!-- 查询列表 -->
      <input-plug ref="queryForm" :form-config="baseConfig" :form-data="queryData" :More="true" @changeCallback="rowCallback">
        <template slot="time1">
          <multitime :timeType="timeType" :timeTypes="timeTypes" :startTime="startTime_a" :endTime="endTime_a" @timestatus="timestatus" @queryBtn_ok="queryBtn_time" />
        </template>
      </input-plug>
    </exportCompoent>
  </div>
</template>
      <script >
import { mixin_1 } from "@/assets/js/Mixins/mixin";
import { mixin_FM } from "@/pages/FinancialManagement/FinancialWriteOff/FMMOD/FMMixin";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import ButotnPlug from "@/components/Modules/ButtonPlug.vue";
import InputPlug from "@/components/Modules/InputPlug.vue";
import multitime from "@/components/multiTime.vue";
import paging from "@/components/pagings.vue"; //分页组件
import TablePlug from "@/components/Modules/TablePlug.vue";
import MyDialog from "@/components/Dialog.vue";
import DiaForm from "@/pages/VMS/VMSConpon/DiaForm.vue";
import uploadimgs from "@/components/upLoadImgs.vue";
import RecordTable from "@/pages/FinancialManagement/FinancialWriteOff/FMMOD/RecordTable.vue";
import exportjs from "@/assets/js/Mixins/export.js"; //导出的公共js
export default {
  mixins: [mixin_1, mixin_FM, exportjs],
  components: {
    ButotnPlug,
    InputPlug,
    multitime,
    TablePlug,
    paging,
    sorttable,
    MyDialog,
    DiaForm,
    uploadimgs,
    RecordTable,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "应付核销总表", //导出时默认文件名
        apiName: "/admin/v3/tms/finance/getFinanceOutAllList", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "GET", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      myTableHeard: [],
      tabelHeadeTitle: [
        {
          name: "关联运单号",
          field: "waybillNumber",
          width: "200",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "收支单据号",
          field: "number",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "责任部门",
          field: "dutyDeptName",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "收支类型",
          field: "financeTypeShow",
          width: "120",
          sort: 5,
          isShow: true,
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "单据类型",
          field: "documentStatusShow",
          width: "120",
          sort: 5,
          isShow: true,
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "来源单据",
          field: "documentNumber",
          width: "120",
          sort: 6,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "费项类型",
          field: "categoryName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "费项",
          field: "serviceName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "结算对象类型",
          field: "objectStatus",
          width: "120",
          sort: 18,
          isShow: true,
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "结算对象",
          field: "objectName",
          width: "120",
          sort: 19,
          isShow: true,
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "结算金额",
          field: "settlementAmount",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "已核销金额",
          field: "writeoffAmount",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "剩余核销金额",
          field: "unwriteoffAmount",
          width: "160",
          sort: 2,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "结算方式",
          field: "settlementMethod",
          width: "120",
          sort: 2,
          isShow: true,
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },

        {
          name: "备注",
          field: "comment",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "对账单号",
          field: "accountStatementNumber",
          width: "120",
          sort: 1,
          isShow: true,
          isSort: true,
        },
        {
          name: "审核状态",
          field: "approveStatusShow",
          width: "120",
          sort: 1,
          isShow: true,
        },
        {
          name: "审核人",
          field: "approverUserName",
          width: "120",
          sort: 180,
          isShow: true,
        },

        {
          name: "核销状态",
          field: "writeoffStatusShow",
          width: "120",
          sort: 6,
          isShow: true,
        },
        {
          name: "最新核销人",
          field: "writeoffUserName",
          width: "120",
          sort: 1,
          isShow: true,
        },

        {
          name: "最新核销时间",
          field: "writeoffTime",
          width: "160",
          sort: 1,
          isShow: true,
          isSort: true,
        },
        {
          name: "最新资金账号",
          field: "zjAccount",
          width: "160",
          sort: 1,
          isShow: true,
        },
        {
          name: "最新核销备注",
          field: "writeoffComment",
          width: "120",
          sort: 1,
          isShow: true,
        },
        {
          name: "过账时间",
          field: "createTime",
          width: "120",
          sort: 1,
          isShow: true,
          isSort: true,
        },
      ],
      tableType: "finance_out",
      sortName: "应付核销总表", //  排序名
      pageGroupName: "PayableWriteoff",
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },
  created() {
    this.GetData();
  },
  methods: {
    // 获取应付总表
    GetData() {
      this.queryData.pageStart = this.pageStart;
      this.queryData.pageTotal = this.pageTotal;
      this.queryData.startCreateTime = this.startTime_a
        ? this.startTime_a + " 00:00:00"
        : "";
      this.queryData.endCreateTime = this.endTime_a
        ? this.endTime_a + " 23:59:59"
        : "";
      this.$API.FinanceOutAllList(this.queryData).then((res) => {
        if (res.data.status === "success") {
          this.className = res.data.result.className || "";
          this.tableConfig.tableData = res.data.result.data || [];
          this.pageCount = res.data.result.pageCount || 0;
          this.$nextTick(() => {
            this.fetTableHeight();
          });
        } else {
          this.$message.error(`${res.data.message}---应付总表`);
        }
      });
    },
    // 获取已启用的资金账号列表
    getAssetaccountList() {
      this.$API.assetaccountList({ isShow: "1" }).then((res) => {
        if (res.data.status === "success") {
          let result = res.data.result?.data || [];
          this.diaFormConfig[0].formItem[1].options = result;
          this.diaFormConfig_2[1].formItem[0].options = result;
        } else {
          console.log(res.data.message);
        }
      });
    },

    //顶部跟多按钮的操作
    topCommandBtns(a) {
      if (a === "bgsz") {
        // 设置模板按钮
        // this.myModel();
        this.$TOOLS.myModel(this);
      }
      if (a === "dyyd") {
        // 打印运单
      }
      if (a === "dybq") {
        // 打印标签
      }
      if (a === "dr") {
        // 导入
      }
      if (a === "dc") {
        // 导出
        // this.exportBtn();
        this.isShowDialog_dc = true;
      }
    },

    // 查询事件
    queryBtn_ok() {
      this.GetData();
    },
    // 查看核销图片
    viewImages(val) {
      let imgs = val?.fileIds || [];
      this.$API.getFileUrlMore({ fileNames: imgs }).then((res) => {
        if (res.data.status === "success") {
          let result = res.data.result;
          this.srcList = [];
          for (let i in result) {
            this.srcList.push(result[i].url);
          }
          this.dialogVisible = true;
        } else {
          console.log(res.data.message);
        }
      });
    },
    // // 表格选择事件
    handleSelectionChange(e) {
      this.selectTableData = e;
    },
    // 跳转运单详情
    goYdDetails(a) {
      this.$message.success("你点我干嘛");
    },

    // 核销记录
    w_selectChange(e) {
      console.log(e);
    },
    w_rowMethods(e, t) {
      this[t](e);
    },
  },
};
</script>
      <style scoped lang="less">
</style>
      